<template>
  <timer-button
    class="rate-archive-button"
    manual
    :props="props"
    @click="click"
    @timeout="() => $emit('timeout')"
    ref="timerButton"
  >
    {{ _value ? "RESTORE" : "ARCHIVE" }}
  </timer-button>
</template>

<script>
import TimerButton from "@/components/partials/TimerButton";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    TimerButton
  },
  data: () => ({
    _value: false,
  }),
  watch: {
    value: {
      handler(value) {
        this._value = value;
      },
      immediate: true,
    },
    _value(value) {
      this.$emit("update:value", value);
    },
  },
  methods: {
    click() {
      this.$refs.timerButton.resetTimer();
      this._value = !this._value;
      this.$emit("click", this._value);
    },
    startTimer() {
      this.$refs.timerButton.startTimer();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Rate/RateArchiveButton.vue